import { QuestionSaleTypeForPlan } from "@/components/features/items/edit/_shared/ui/components/main/questions/sale-type-for-plan";

import { useOptionSaleTypeForPlan } from "./hooks";

export const QuestionOptionSaleTypeForPlan = () => {
	const { saleTypeForPlan, onSetSaleTypeForPlan, saleTypeForPlanOptions } = useOptionSaleTypeForPlan();

	return (
		<QuestionSaleTypeForPlan
			saleTypeForPlan={saleTypeForPlan}
			onSetSaleTypeForPlan={onSetSaleTypeForPlan}
			saleTypeForPlanOptions={saleTypeForPlanOptions}
		/>
	);
};

QuestionOptionSaleTypeForPlan.displayName = "QuestionOptionSaleTypeForPlan";
